import React from 'react';
import { StreamingOverviewResponse } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../../common/types';
import { PeriodSectionGateView } from '../../period/PeriodSectionGateView';
import { acceleratorMessages as messages } from '../../acceleratorMessages';
import { AcceleratorBody } from './AcceleratorBody';

interface AcceleratorSectionProps {
  accountId: number;
  overview: StreamingOverviewResponse;
  onOpenCatalog: () => void;
}

/** Streaming → Accelerator (design streaming-sections d1, d2, e4): TuneCore Accelerator per month. */
const AcceleratorSectionComponent: React.FC<AcceleratorSectionProps> = ({ accountId, overview, onOpenCatalog }) => (
  <PeriodSectionGateView
    overview={overview}
    section="accelerator"
    emptyTitle={messages.emptyTitle}
    emptyText={messages.emptyText}
    onOpenCatalog={onOpenCatalog}
  >
    <AcceleratorBody accountId={accountId} days={overview.days} />
  </PeriodSectionGateView>
);

export const AcceleratorSection = TypedMemo(AcceleratorSectionComponent);
